import { Injectable } from '@angular/core';
import { QualityControlAuthService } from '../../../../common/quality-control/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HosesAuthQcService extends QualityControlAuthService {
  protected totalPermits = ['QualityControl', 'Admin'];
  protected rolesToRegisterData = ['QualityControlInspector', 'HosesQC'];

  registerData(): boolean {
    return this.accessTo(this.rolesToRegisterData);
  }

  validateTests(): boolean {
    return this.accessTo(this.rolesToRegisterData);
  }

  totalInspection(): boolean {
    return this.accessTo(['QualityControl']);
  }
}
